import { render, staticRenderFns } from "./contenu-restitution.vue?vue&type=template&id=3a006549"
import script from "./contenu-restitution.vue?vue&type=script&lang=js"
export * from "./contenu-restitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports